import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class NumberComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentNumber | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.decimalLimit = settings?.decimalLimit ?? 0;
		this.defaultValue = settings?.defaultValue ?? '';
		this.delimiter = settings?.delimiter ?? false;
		this.disabled = settings?.disabled ?? false;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.input = true;
		this.inputType = settings?.inputType ?? 'number';
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.placeholder = settings?.placeholder ?? '';
		this.prefix = settings?.prefix ?? '';
		this.protected = settings?.protected ?? false;
		this.requireDecimal = settings?.requireDecimal ?? false;
		this.suffix = settings?.suffix ?? '';
		this.validate = {
			card:          new Card(settings?.validate?.card ?? '0-1'),
			custom:        settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
			integer:       settings?.validate?.integer ?? '',
			max:           settings?.validate?.max ?? '',
			min:           settings?.validate?.min ?? '',
			step:          settings?.validate?.step ?? 'any',
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'name',
		]);
	}
}
